/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const cookie = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <g clipPath="url(#cookie_svg__a)">
      <path
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        d="M10.813 9.003h.347m-4.337 2.361h.346m6.43-5.237a2.333 2.333 0 0 1-2.334-2.348 2.314 2.314 0 0 1-2.511.2A2.334 2.334 0 0 1 7.716 1a6.998 6.998 0 0 0-6.434 5.03 7.006 7.006 0 0 0 2.707 7.707 6.998 6.998 0 0 0 10.672-3.586 7.005 7.005 0 0 0 .005-4.29 2.309 2.309 0 0 1-1.067.266ZM7 6.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm4.239 2.503c0 .183-.16.243-.248.243-.092 0-.252-.06-.252-.243 0-.197.16-.257.252-.257.088 0 .248.06.248.257Zm-3.99 2.361c0 .184-.16.244-.249.244-.092 0-.252-.06-.252-.244 0-.196.16-.256.252-.256.088 0 .248.06.248.256Z"
      />
    </g>
    <defs>
      <clipPath id="cookie_svg__a">
        <path fill="#fff" d="M0 0h16v16H0z" />
      </clipPath>
    </defs>
  </svg>
)
export default cookie
